module.exports = __webpack_public_path__ + "static/media/ic_downloadBlue.fcf88576.svg";